// 세로 ERP 맞춤형 월 이용료 계산. 홈페이지 견적 계산기와 가격표가 같은 식을 쓰도록 한 곳에 둔다.
//
//   50명 이하(여유 55명까지)  → 월 50만원 정액
//   그보다 많으면            → 기본료 50만원(관리자 5명 + 나머지 20명 포함)
//                              + 관리자 구간 요금 + 나머지 인원 구간 요금
//   구간 요금 = 그 구간에 들어간 인원 × 구간 단가 (넘은 인원만 다음 단가 — 누적 계산)
import pricing from "./sero-pricing.json";

const { custom, estimator } = pricing;

function tierLines(count, tiers) {
  return tiers
    .map(({ from, to, price, discount }) => {
      const upper = to == null ? count : Math.min(count, to);
      const people = Math.max(0, upper - from + 1);
      return { from, to, price, discount, people, amount: people * price };
    })
    .filter((line) => line.people > 0);
}

export function quoteCustom(admins, others) {
  const a = Math.max(0, Math.floor(admins || 0));
  const o = Math.max(0, Math.floor(others || 0));
  const total = a + o;
  const listPrice =
    custom.baseFee +
    Math.max(0, a - custom.includedAdmins) * custom.adminListPrice +
    Math.max(0, o - custom.includedOthers) * custom.otherListPrice;
  if (total <= custom.graceUsers) {
    return { admins: a, others: o, total, flat: true, monthly: custom.baseFee, adminLines: [], otherLines: [], listPrice: custom.baseFee, discountRate: 0 };
  }
  const adminLines = tierLines(a, custom.adminTiers);
  const otherLines = tierLines(o, custom.otherTiers);
  const monthly = custom.baseFee + [...adminLines, ...otherLines].reduce((sum, line) => sum + line.amount, 0);
  return {
    admins: a, others: o, total, flat: false, monthly, adminLines, otherLines, listPrice,
    discountRate: listPrice > 0 ? Math.round((1 - monthly / listPrice) * 100) : 0,
  };
}

// 계약 전 질문 5개로 예상 계정 수를 잡는다. 협력업체·고객사는 1곳당 평균 계정 수를 곱해 올림.
export function estimateAccounts({ staff = 0, directors = 0, hqs = 0, vendors = 0, clients = 0 }) {
  const n = (v) => Math.max(0, Math.floor(Number(v) || 0));
  const hqAccounts = n(hqs) * estimator.accountsPerHq;
  const vendorAccounts = Math.ceil(n(vendors) * estimator.accountsPerVendor);
  const clientAccounts = Math.ceil(n(clients) * estimator.accountsPerClient);
  const others = n(directors) + hqAccounts + vendorAccounts + clientAccounts;
  return { admins: n(staff), others, directors: n(directors), hqAccounts, vendorAccounts, clientAccounts };
}

export const wonFull = (value) => `${Math.round(value).toLocaleString("ko-KR")}원`;
// 만원 단위, 소수 한 자리까지 (예: 62.5만원)
export const wonMan = (value) => {
  const man = Math.round(value / 1000) / 10;
  if (man >= 10000) {
    const eok = Math.floor(man / 10000);
    const rest = Math.round(man - eok * 10000);
    return rest ? `${eok}억 ${rest.toLocaleString("ko-KR")}만원` : `${eok}억원`;
  }
  return `${man.toLocaleString("ko-KR")}만원`;
};
